export enum NOTIFICATION_TYPE {
	CASE = 'CASE',
	MESSAGE = 'MESSAGE',
	LINK = 'LINK',
	DOCUMENTATION_FILE = 'DOCUMENTATION_FILE',
	EVENTS = 'EVENTS',
	PATIENT_PROFILE = 'PATIENT_PROFILE',
	PATIENT_PROFILE_UPDATE = 'PATIENT_PROFILE_UPDATE',
	NEW_IN_MEDDI_MD = 'NEW_IN_MEDDI_MD',
	LABORATORY_RESULT = 'LABORATORY_RESULT',
}
